'use client'

import FullProdSlider from '@/components/catalog/FullProdSlider'
import Header from '@/components/header/Header'
import React, { useEffect } from 'react'
// import logoMain from '@/assets/img/logo-main.svg'
import logoMain from '@/assets/img/dark-vers.svg'
import MainAbout from '@/components/main/MainAbout'
import bg from '@/assets/img/products/production-bg.png'
import MainOrder from '@/components/main/MainOrder'
import userIcon from '@/assets/img/user.svg'
import MainSlider from '@/components/main/MainSlider'
import { categoriesSliderList } from '@/assets/data/useful-materials'
import materialsSettings from '@/assets/data/main-materials-slider.json'
import Footer from '@/components/Footer/Footer'
import Link from 'next/link'
import { useGetMaterialsCategoriesQuery } from '@/redux/services/materialsApi'
import { useDispatch } from 'react-redux'
import { setResetCatalogFilters, setResetMaterialsFilters, setResetNewsFilters } from '@/redux/features/filterSlice'
import MainSceneWithWrapper from '@/components/MainSceneWithWrapper/MainSceneWithWrapper'
import CardSlider from '@/components/CardSlider'
import { useTranslation } from 'react-i18next'

// const consultingItem = {
//     page: 'consulting',
//     items: [
//         {
//             title: 'Консалтинг',
//             text: [t("consulting_services_of")],
//             cardClass: 'product__slide'
//         },
//         {
//             title: t("electronic_egg"),
//             text: [t("megamix_conducts_a_technical_audit")],
//             cardClass: 'product__slide'
//         },
//         {
//             title: t("unique_diet_optimization"),
//             text: [t("MEGAMICS_group_of_companies_is_a_licensed")],
//             cardClass: 'product__slide'
//         }
//     ]
// }

const ConsultingModule = () => {
    const { data: materialsCategoriesData } = useGetMaterialsCategoriesQuery()
    const { t } = useTranslation()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setResetNewsFilters())
        dispatch(setResetMaterialsFilters())
        dispatch(setResetCatalogFilters())
    }, [])

    const headSliderList = [
        t('consulting'),
        t("electronic_egg"),
        t("unique_diet_optimization")
    ]

    const consultingItem = {
        items: [
            {
                title: t('consulting'),
                text: [
                    t("consulting_services_of")
                ],
                cardClass: 'product__slide'
            },
            {
                title: t("electronic_egg"),
                text: [
                    t("megamix_conducts_a_technical_audit")
                ],
                cardClass: 'product__slide'
            },
            {
                title: t("unique_diet_optimization"),
                text: [
                    t("MEGAMICS_group_of_companies_is_a_licensed")
                ],
                cardClass: 'product__slide'
            }
        ],
        btn: {
            content: t('moreDetailedTest'),
            link: '#about',
            icon: 'details'
        }
    }

    const egg = {
        tag: t("service"),
        title: t("electronic_egg"),
        text: [
            t("a_fresh_egg_of_good_quality"),
            t("by_auditing_mechanized_egg_collection")
        ],
        btn: {
            content: t('moreDetailedTest'),
            link: '/useful-materials/elektronnoe-yayco:-audit-sistem-mehanizirovannogo-yaycesbora-pri-pomoschi-elektronnogo-sensora',
            icon: 'egg'
        }
    }

    const microClimate = {
        tag: t("service"),
        title: t("microclimate_analysis"),
        text: [
            t("description_what_you_will_find_in_this_section"),
            t("on_the_other")
        ]
    }

    const ndsPro = {
        tag: t("service"),
        title: 'NDS Pro',
        text: [
            t("the_unique_ration_optimization_service")
        ],
        btn: {
            content: t("laboratoriesP"),
            link: 'https://lab.megamix.ru/login/',
            icon: 'user'
        },
        btn2: {
            content: t('moreDetailedTest'),
            link: '/useful-materials/unikalnyy-servis-po-optimizacii-racionov-NDS-Professional',
            icon: 'details'
        }
    }

    return (
        <main className='main consulting'>
            {/* <div className="home__light-blue"></div>
            <div className="home__purple-1"></div>
            <div className="home__purple-2"></div>
            <div className="home__violet"></div> */}
            <Header burgerBg='linear-gradient(180deg, #3156A8 21.87%, #2D3079 108.55%)' />
            <MainSceneWithWrapper
                zInx={-1}
                bottomBlur
            />
            <div className='container'>
                <div className='media__top consulting__top'>
                    <Link href={'/#map-cards'}>
                        <button className='buttons buttons__maps'>
                            <svg
                                width='19'
                                height='19'
                                viewBox='0 0 19 19'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <g opacity='0.6'>
                                    <path
                                        d='M1 3.34483L5.95833 1V15.6552L1 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                    <path
                                        d='M12.3334 3.34483L18 1V15.6552L12.3334 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                    <path
                                        d='M12.3334 3.34483L5.95837 1V15.6552L12.3334 18V3.34483Z'
                                        stroke='#CBD9F9'
                                        strokeWidth='1.6'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    />
                                </g>
                            </svg>
                            {t('BackToMap')}
                        </button>
                    </Link>
                    {/* <FullProdSlider
                        list={consultingItem}
                        page='import'
                        link='#about'
                        headSlider={headSliderList} /> */}
                    <CardSlider
                        list={consultingItem}
                        headSlider={headSliderList}
                    />
                </div>
                <MainAbout
                    bg={bg}
                    item={egg}
                />
                <MainOrder
                    item={microClimate}
                    btnContent={t('sendEnquiry')}
                    link1={''}
                />
                <MainAbout
                    bg={bg}
                    item={ndsPro}
                />
                <div className='container'>
                    <h2 className='main__section-title'>{t('usefulMaterialsTitle')}</h2>
                </div>
            </div>
            {materialsCategoriesData && (
                <MainSlider
                    settings={materialsSettings}
                    type={'useful-materials'}
                    list={materialsCategoriesData}
                />
            )}
            {/* <div className="container"> */}
            <Footer />
            {/* </div> */}
        </main>
    )
}

export default ConsultingModule
